import { B2cLoginViewForm } from '../../../../../com/ibm/tw/commons/mvc/b2c.login.viewform';

/**
 * 中國子行快速連結服務 viewform.
 */
export class CtwflcnbkViewForm extends B2cLoginViewForm {

  /** loginUrl. */
  loginUrl: string;
}